import { howToSteps } from "@/mocks/howTo";

export default function HowToUse() {
  return (
    <section id="guide" className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">使用指南</span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              四步挑完，不浪费时间
            </h2>
          </div>
          <p className="max-w-md text-xs leading-5 text-foreground-600">
            这个导航站不替你加工内容，只负责把入口摆清楚。照着下面四步走，基本不会点空。
          </p>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {howToSteps.map((step) => (
            <li key={step.id} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="flex items-center justify-between">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${step.icon} text-base`} />
                </span>
                <span className="font-heading text-2xl font-black text-background-300">{step.step}</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-700">{step.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-6 flex flex-col gap-3 rounded-lg border border-accent-200 bg-accent-50 p-4 md:flex-row md:items-center md:justify-between md:p-5">
          <div className="flex items-start gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-information-line text-base" />
            </span>
            <div>
              <p className="font-heading text-sm font-bold text-accent-900">入口校验说明</p>
              <p className="mt-1 text-xs leading-5 text-accent-800">
                列表中的入口会定期做一次可访问性校验，异常入口先加标记再下架；若你遇到标注不符的情况，记下入口名，下次整理时会优先复查这一条。
              </p>
            </div>
          </div>
          <a
            href="#faq"
            className="shrink-0 cursor-pointer whitespace-nowrap rounded-md border border-accent-300 bg-background-50 px-4 py-2 text-center text-xs font-medium text-accent-900 transition-colors hover:bg-accent-100"
          >
            看看常见问题
          </a>
        </div>
      </div>
    </section>
  );
}